export default "{\n    \"clientUser\": \"Cliente\",\n    \"vendorUser\": \"Proveedor\",\n    \"internalUser\": \"ResQ\"\n}\n"